<template>
  <el-dialog :visible="hotGameList" class="emptyAct" @close="closeHotList">
    <p class="top">
      <span class="current account">{{ $t("currentAccount") }}:</span
      ><span class="account">{{ nickname }}</span>
      <el-button @click="loginOut" class="loginBtn float-r"
        >{{ $t("reLogin") }}
      </el-button>
    </p>
    <p class="line"></p>
    <p class="emptyMsg">
      {{ $t("emptyMsg") }}
    </p>
    <p class="emptyMsg or">— or —</p>
    <p class="emptyMsg newGame">{{ $t("goNewGame") }}</p>
    <div class="newGameList">
      <router-link
        v-for="(item, index) in imgList"
        :to="'/detail/index?id=' + item.gameId"
        :key="index"
      >
        <img alt="" :src="item.iconUrl" @click="choseForm"/>
      </router-link>
    </div>
    <div class="countDown">{{ count }}s</div>
  </el-dialog>
</template>
<script>
import { getHotGameList } from "@/api/gameList";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      imgList: [],
      count: 10,
      timeId: null,
    };
  },
  computed: {
    ...mapGetters(["nickname", "hotGameList"]),
  },
  mounted() {
    this.getHotGameList();
    this.timeId = setInterval(() => {
      this.count--;
      if (this.count == 0) {
        this.$store.dispatch("hotGameList", false);
        window.clearInterval(this.timeId);
      }
    }, 1000);
  },

  methods: {
    getHotGameList() {
      getHotGameList({ num: 3 }).then((res) => {
        this.imgList = res;
      });
    },
    closeHotList() {
      window.clearInterval(this.timeId);
      this.$store.dispatch("hotGameList", false);
    },
    loginOut() {
      this.$store.dispatch("loginOut");
    },
    choseForm(){
      this.$store.dispatch("hotGameList", false);
    }
  },
};
</script>
<style lang="scss">
.emptyAct {
  .top {
    height: 60px;
  }
  .current {
    margin: 10px 10px 0 40px;
  }
  .account {
    color: #9c9c9c;
    font: normal bold 16px/60px arial;
  }
  .loginBtn {
    margin: 10px 60px 0 0;
    border-radius: 30px;
    border: none;
    color: #ffffff;
    background: #7b7b7b;
    font-weight: 700;
  }
  .emptyMsg {
    text-align: center;
    color: #ffffff;
    font-size: 20px;
    line-height: 70px;
  }
  .line {
    height: 2px;
    background-image: linear-gradient(to right, #2c2c2c, #de9a2d, #2c2c2c);
  }
  .or {
    color: #9c9c9c;
  }
  .newGame {
    color: #d3b120;
    font-size: 18px;
  }
  .newGameList {
    height: 190px;
    padding: 0 30px;
    display: flex;
    justify-content: space-around;
    img {
      height: 130px;
      width: 130px;
    }
  }
  .countDown {
    text-align: center;
    color: #ffffff;
  }
  .el-dialog {
    background: #2c2c2c;
    height: 540px;
    width: 520px;
    .el-dialog__body {
      padding-top: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/emptyAccount.vue